import PatientSignatureImage from './PatientSignatureImage';

const GenreralConsent = ({
    pageRefs,
    currentPage,
    logo,
    pageTitles,
    SurgeryFormData,
    surgeonOptionsMap,
    docSignature,
    setSignatures,
    setSurgeryFormData,
    handleInputChange,
    invalidFields,
    isNext,
    isEditing,
    signatures,
    canvasRefs,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    getCentralAmericaDate,
    getCentralAmericaTime,
    Logo,
    Head,
    Paragraph,
    RadioGroup,
    TextInput,
    SignatureField,
    SegLogoBanner,
    Initials,
    surgeryUpload,
    FormInput,
    handleCheckboxChange,
    formattedDate,
    EyeSelector,
    SegFooter
}) => {

    return (
        <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white">
            <SegLogoBanner src={logo} />

            <div className="px-1 mx-8 py-2">
                <Head title="General Consent for Medical and Surgical Procedures" />

                {
                    SurgeryFormData.surgeon.toLowerCase().includes('sugg') &&
                    (
                        <Paragraph>
                            Patient Name: <span className="underline font-bold">{SurgeryFormData.first_name} {SurgeryFormData.last_name}</span>  DOB: <span className="underline font-bold">{SurgeryFormData.dob}</span>
                        </Paragraph>
                    )
                }



                <Paragraph >
                    You have been given information about your condition and the recommended surgical, medical or diagnostic procedure(s) to be used. This consent form is designed to provide a written confirmation of such discussions by recording some of the more significant medical information given to you. It is intended to make you better informed so that you may give or withhold your consent to the proposed procedure(s).
                </Paragraph>
                {
                    SurgeryFormData.surgeon.toLowerCase().includes('corder') &&
                    (
                        <>
                            <Paragraph>1. Condition: Dr. Donna Corder has explained to me that the following condition(s) exist in my case: </Paragraph>
                            <TextInput
                                id="diagnosis"
                                label=""
                                value={SurgeryFormData.diagnosis}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("diagnosis") && !SurgeryFormData.diagnosis}
                            />
                            <Paragraph>2. Proposed Procedure(s): I understand that the procedure(s) proposed for evaluation and treating my
                                conditions is/are:  </Paragraph>
                            <TextInput
                                id="procedure"
                                label=""
                                value={SurgeryFormData.procedure}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("procedure") && !SurgeryFormData.procedure}
                            />
                            <EyeSelector
                                SurgeryFormData={SurgeryFormData}
                                handleInputChange={handleInputChange}
                            />
                        </>

                    )
                }

                {
                    SurgeryFormData.surgeon.toLowerCase().includes('sugg') &&
                    (
                        <>
                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <TextInput
                                    id="diagnosis"
                                    label="1. Diagnosis"
                                    value={SurgeryFormData.diagnosis}
                                    onChange={handleInputChange}
                                    disabled={isNext}
                                    invalid={invalidFields.includes("diagnosis") && !SurgeryFormData.diagnosis}
                                />

                                <EyeSelector
                                    SurgeryFormData={SurgeryFormData}
                                    handleInputChange={handleInputChange}
                                />
                            </div>
                            <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <TextInput
                                    id="procedure"
                                    label="2. Procedure"
                                    value={SurgeryFormData.procedure}
                                    onChange={handleInputChange}
                                    disabled={isNext}
                                    invalid={invalidFields.includes("procedure") && !SurgeryFormData.procedure}
                                />
                                <EyeSelector
                                    SurgeryFormData={SurgeryFormData}
                                    handleInputChange={handleInputChange}
                                />
                            </div>
                        </>

                    )
                }
                <span className="underline font-bold">3. Risks/Benefits of Proposed Procedure(s):</span>
                <Paragraph>
                    A. Just as there may be benefits to the procedure(s) proposed, I also understand that medical and surgical procedures involve risks. These risks include allergic reaction, bleeding, blood clots, infections, adverse side effects of drugs, blindness, and even loss of bodily function or life, as well as risks of transfusion reactions and the transmission of infectious disease, including Hepatitis and Acquired Immune Deficiency Syndrome, from the administration of blood and/or blood components.
                </Paragraph>
                <Paragraph>
                    B. I also realize that there are particular risks associated with the procedure(s) proposed for me and
                    that these risks include but are not limited to those enumerated in the addendum.
                </Paragraph>
                <Paragraph>
                    <span className="underline font-bold">4. Complications; Unforeseen Conditions; Results:</span> : I am aware that in the practice of medicine, other
                    unexpected risks or complications not discussed may occur. I also understand that during the course of the proposed procedure(s) unforeseen conditions may be revealed requiring the performance of additional procedures, and I authorize such procedures to be performed. I further acknowledge that no guarantees or promises have been made to me concerning the result of any procedure or treatment.
                </Paragraph>

                <Paragraph>
                    <span className="underline font-bold">5. Acknowledgement:</span> :  The available alternatives, the potential benefits and risk of the proposed
                    procedure(s), and the likely result without such treatment, have been explained to me. I understand what has been discussed with me as well as the contents of this consent form and have been given the opportunity to ask questions and have received satisfactory answers.
                </Paragraph>



                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <PatientSignatureImage
                        signature={SurgeryFormData['patient_signature']}
                        label="Patient/Guardian Signature"
                        signedDate={SurgeryFormData.patientSignedDate}
                    />
                    <div className="flex items-center gap-3">
                        <PatientSignatureImage
                            signature={SurgeryFormData['witness_signature']}
                            label="Witness Signature"
                            signedDate={SurgeryFormData.witnessSignedDate}
                        />

                        {(!isNext && !SurgeryFormData.witnessSignedDate) && (
                            <button
                                type="button"
                                onClick={() =>
                                    setSurgeryFormData({
                                        ...SurgeryFormData,
                                        witnessSignedDate: getCentralAmericaDate(),
                                        witnessSignedTime: getCentralAmericaTime(),
                                    })
                                }
                                disabled={isNext}
                                className="p-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white focus:outline-none"
                                title="Set Central America Date & Time"
                            >
                                <i className="fas fa-calendar-days text-white text-lg"></i>
                            </button>
                        )}
                    </div>
                </div>

                <PatientSignatureImage
                    signature={SurgeryFormData['doctor_signature']}
                    label="Physician/Surgeon"
                    signedDate={formattedDate}
                />


            </div>
            <div className="mb-2">
                <SegFooter />
            </div>
        </div>
    );
};

export default GenreralConsent;